export default "__VITE_ASSET__BYRN6GlK__"